import { useQuery } from "@tanstack/react-query";
import { useLoginContext } from "../../../App";
import { fetchOrganizationActiveLicense } from "../../../services/b2b-users-apiService";
import { useContentContext } from "../../layout/Layout";
import { showNotification } from "../../b2b-common/Notification";
import useB2BTranslation from "../../b2b-common/hooks/useB2BTranslation";
import { useState } from "react";

const useGetActiveLicense = () => {
    const { loginData } = useLoginContext();
    const { setNotification } = useContentContext();
    const { t } = useB2BTranslation('b2b-users');
    const [isFetching, setIsFetching] = useState(false);

    const getActiveLicense = async () => {
        try {
            if (loginData) {
                setIsFetching(true);
                const { accessToken, loggedOrganizationUuid } = loginData;
                return await fetchOrganizationActiveLicense(loggedOrganizationUuid, accessToken);
            }
        } catch (error) {
            console.error('Failed to fetch active license:', error.message);
            showNotification(setNotification, t('Failed to fetch active license.'), 'error', 5000);
        } finally {
            setIsFetching(false);
        }
    }

    const { data: activeLicenseData } = useQuery({
        queryKey: ['activeLicenseData', loginData.loggedOrganizationUuid],
        queryFn: getActiveLicense,
        enabled: !!loginData?.loggedOrganizationUuid,
        staleTime: 15 * 60 * 1000, // 15 minutes
        cacheTime: 15 * 60 * 1000, // 15 minutes
    });

    return { activeLicenseData, isFetching };
}

export default useGetActiveLicense;